// extracted by mini-css-extract-plugin
export var chevronIcon = "_dc-2";
export var teamName = "_dc-1";
export var teamSwitcherButton = "_dc-0";